var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVdreamLogoRenewal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 815,
    height: 224,
    viewBox: "0 0 815 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.681 207.828V220.671H207.448V207.828H277.681ZM273.861 198.561H211.269V155.315H224.762V165.151H260.367V155.315H273.861V198.561ZM260.367 186.368V177.182H224.762V186.368H260.367Z",
    fill: "#584C9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.048 162.767C361.923 168.267 363.874 176.532 363.874 187.587C363.874 198.642 361.923 206.933 358.048 212.434C354.174 217.934 348.836 220.698 342.062 220.698C335.288 220.698 329.95 217.934 326.048 212.434C322.146 206.933 320.195 198.669 320.195 187.587C320.195 176.504 322.146 168.267 326.048 162.767C329.95 157.266 335.288 154.502 342.062 154.502C348.836 154.502 354.147 157.266 358.048 162.767ZM333.77 187.587C333.77 201.243 336.534 208.071 342.062 208.071C347.589 208.071 350.272 201.243 350.272 187.587C350.272 180.325 349.54 175.095 348.05 171.898C346.56 168.701 344.555 167.102 342.062 167.102C336.534 167.102 333.77 173.93 333.77 187.587ZM385.307 223.11H371.569V153.689H385.307V223.11Z",
    fill: "#584C9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M499.111 220.671H428.878V207.828H499.111V220.671ZM495.29 168.078H446.761V185.555H496.103V198.236H432.698V155.315H495.29V168.078Z",
    fill: "#584C9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M584.057 178.564H555.444V182.547H573.327C576.47 182.547 579.478 182.33 582.35 181.897C585.222 181.463 587.553 180.867 589.341 180.108V190.513C587.553 191.272 585.222 191.868 582.35 192.301C579.478 192.735 576.416 192.952 573.165 192.952H541.869V168.89H570.482V164.907H541.706V154.502H584.057V178.564ZM606.737 223.11H544.632V196.61H606.737V223.11ZM593.08 212.38V207.34H558.289V212.38H593.08ZM606.737 194.171H592.999V153.689H606.737V194.171Z",
    fill: "#584C9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7849 0L63.2966 99.8493H52.973L85.4341 0H95.7849Z",
    fill: "#2EB6AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3002 0L42.8119 99.8493H32.4883L64.9495 0H75.3002Z",
    fill: "#2EB6AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8247 52.7291L30.8083 0H0L32.4883 99.8493L47.8247 52.7291Z",
    fill: "#584C9D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M705.665 0V99.8493H734.116V46.4699L750.915 99.8493L763.759 60.2889L744.927 0H705.665Z",
    fill: "#584C9D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M790.665 72.428V99.8493H814.212V0L790.665 72.428Z",
    fill: "#584C9D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M783.404 0L750.915 99.8493H761.239L793.727 0H783.404Z",
    fill: "#2EB6AA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M803.861 0L771.4 99.8493H781.724L814.212 0H803.861Z",
    fill: "#2EB6AA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 99.8493V0H184.335C201.108 0 213.68 4.98568 221.999 14.93C230.344 24.8742 234.517 36.3901 234.517 49.4505C234.517 64.3804 230.046 76.4924 221.105 85.8406C212.163 95.1888 200.539 99.8493 186.259 99.8493H145.723ZM176.369 76.8717H184.335C189.402 76.8717 193.683 74.406 197.179 69.4745C200.674 64.543 202.408 57.8503 202.408 49.3692C202.408 42.1074 200.864 35.8482 197.775 30.5644C194.686 25.3078 190.215 22.6524 184.362 22.6524H176.396V76.8447L176.369 76.8717Z",
    fill: "#584C9D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M381.297 99.8493H347.318L332.741 61.6708H323.067V99.8493H292.422V0H344.582C356.098 0 365.039 2.68251 371.38 8.07464C377.747 13.4668 380.918 20.566 380.918 29.3993C380.918 35.1437 379.752 40.2378 377.395 44.6544C375.065 49.0711 370.323 52.9459 363.197 56.3329L381.27 99.8493H381.297ZM323.067 40.3191H336.155C340.002 40.3191 343.091 39.5062 345.449 37.9075C347.806 36.3088 348.971 33.9244 348.971 30.8083C348.971 24.4136 345.042 21.2163 337.184 21.2163H323.067V40.3191Z",
    fill: "#584C9D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M515.856 76.0047V99.8493H440.719V0H515.856V23.0317H470.795V37.5282H507.213V59.6928H470.795V76.0047H515.856Z",
    fill: "#584C9D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M559.915 99.8493L592.403 0H602.727L570.265 99.8493H559.915Z",
    fill: "#2EB6AA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M580.399 99.8493L612.888 0H623.211L590.75 99.8493H580.399Z",
    fill: "#2EB6AA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M607.875 47.1202L624.891 99.8493H655.7L623.211 0L607.875 47.1202Z",
    fill: "#584C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdreamLogoRenewal);
export default __webpack_public_path__ + "resume/static/media/vdream_logo_renewal.4f9fa5030e8393c92e6d0a48788c0806.svg";
export { ForwardRef as ReactComponent };